export default __webpack_public_path__ + "components/weather-icon/static/daycloud@3-9460ad579f997b433cd09a5652b19639.png";